import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ModelBase,
} from "@models";
import { 
  EncounterComplication, 
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function EncounterComplicationEdit({ obj: param_obj }: Props) {
  const [obj, setObj] = useState<EncounterComplication>(param_obj instanceof EncounterComplication ? param_obj : api.applyWorkingOn(new EncounterComplication()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);

  const updateObj = (updater: (o: EncounterComplication) => void) => {
    const new_obj = obj.clone(); // clone, don't mutate
    updater(new_obj);
    setObj(new_obj);
    setChangeTime(common_util.get_time_number());
  };

  return (
    <ModelBaseInput
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof EncounterComplication) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}>
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          <SelectObjectBox
            name="Suggested for Environments (leave empty for any)"
            data_type="environment"
            values={obj.environment_ids}
            multiple
            disabled={disabled}
            onChange={(changed: string[]) => updateObj(o => { o.environment_ids = changed; })}
          />
        </Grid>
      </Grid>
    </ModelBaseInput>
  );
}
